import React, { Component } from 'react';
import classnames from 'classnames';
import axios from 'axios';

class GlobalEntityTab extends Component {

  tabType = "GLOBAL_ENTITY";

  config = {
    responseType : 'json',
    crossdomain : true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
    }
  }
  
  thisTabClicked = (e) => {
    const { tabClicked } = this.props;
    tabClicked(this.tabType);
  }

  render() {
    
    const { thisTabClicked } = this;
    const { activeTabType } = this.props;

    const globalEntityTabClass = classnames({
      "col-sm" : true,
      "list-tab" : true,
      "last-tab" : this.props.isLastTab,
      "active" : activeTabType === this.tabType ? true : false
    })

    return (
      <div className={globalEntityTabClass}
        onClick={thisTabClicked}>
        글로벌 엔티티
      </div>
    );
  }
}

export default GlobalEntityTab;